import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<div *ngIf="form">
  <form [formGroup]="form">
    <se-po-ethnicity-select
      formControlName="ethnicity"
      seFeDataLabel="Race And Ethnicity">
    </se-po-ethnicity-select>
  </form>
  <div class="form-value">
    <code>
      {{ form.value | json }}
    </code>
  </div>
</div>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'

export class EthnicitySelectExampleComponent implements OnInit {
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder
  ) { }

  public ngOnInit(): void {
    this.form = this.fb.group({
      ethnicity: [null]
    })
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-ethnicity-select-example',
  template,
  styleUrls: ['./ethnicity-select-docs.component.scss'],
  standalone: false,
})
export class EthnicitySelectExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder
  ) {
    super()
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      ethnicity: [null]
    })
  }
}
